"use client"

import React from 'react';
import MapComponent from "@/components/Map/MapComponent";
import PlaceMarker from "@/components/SingleSegment/PlaceMarker";
import {Place} from "@/types/Places";

export default function SinglePlaceMap(props: { data: Place }) {

  return <div>
    <MapComponent
      lat={props.data.latitude}
      lng={props.data.longitude}
      style={{width: '100%', height: '400px'}} zoom={12}>
      <PlaceMarker segment_id={props.data.segment_id} item={props.data}/>
    </MapComponent>
  </div>
}
